export enum LocalizationKeyErrors {
    KEY_NOT_FOUND = 1
}
